module.exports = __webpack_public_path__ + "static/media/image002.37cbf3b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/app2soft/images/image002.png
// module id = 299
// module chunks = 0